<script setup lang="ts">
import { Layout, LayoutContent } from 'ant-design-vue'
import AppHeader from '../components/AppHeader.vue'
import AppSidebar from '../components/AppSidebar.vue'
import AppFooter from '../components/AppFooter.vue'
import PageHeader from '../components/PageHeader.vue'
import { useDefaultLayout } from '../composables/useDefaultLayout'

const { isMobile, sidebarWidth } = useDefaultLayout()
</script>

<template>
 <Layout class="crm-shell">
  <AppSidebar />
  <Layout
   class="crm-main"
   :style="{ marginLeft: isMobile ? '0' : `${sidebarWidth}px` }"
  >
   <AppHeader />
   <PageHeader />
   <LayoutContent class="crm-content">
    <main class="crm-content__scroll custom-scrollbar">
     <RouterView />
     <AppFooter />
    </main>
   </LayoutContent>
  </Layout>
 </Layout>
</template>
